// Peakspan LaserMask — progressive enhancement only; the page works without JS.
document.addEventListener('DOMContentLoaded', function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var header = document.querySelector('.site-header');
  var headerTicking = false;

  function updateHeader() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
    headerTicking = false;
  }

  function requestHeaderUpdate() {
    if (!headerTicking) {
      headerTicking = true;
      requestAnimationFrame(updateHeader);
    }
  }

  updateHeader();
  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });

  var mobileNav = document.querySelector('.mobile-nav');
  if (mobileNav) {
    var mobileSummary = mobileNav.querySelector('summary');
    function updateMobileNavLabel() {
      if (!mobileSummary) return;
      var label = mobileNav.open ? mobileSummary.getAttribute('data-close-label') : mobileSummary.getAttribute('data-open-label');
      if (label) mobileSummary.setAttribute('aria-label', label);
    }
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { mobileNav.open = false; });
    });
    mobileNav.addEventListener('toggle', updateMobileNavLabel);
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !mobileNav.open) return;
      mobileNav.open = false;
      if (mobileSummary) mobileSummary.focus();
    });
    document.addEventListener('click', function (event) {
      if (mobileNav.open && !mobileNav.contains(event.target)) mobileNav.open = false;
    });
    updateMobileNavLabel();
  }

  var revealItems = document.querySelectorAll('.badge, .intro-copy, .intro-visual, .wave, .use-step, .sci-card, .dark-section > *, .split > *, .timeline .tl-item, .g-card, .review, .spec, .order-card, .faq-list details');
  if (!reducedMotion && 'IntersectionObserver' in window && revealItems.length) {
    document.documentElement.classList.add('reveal-ready');
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    revealItems.forEach(function (item, index) {
      item.classList.add('reveal-item');
      item.style.setProperty('--reveal-delay', (index % 4) * 45 + 'ms');
      revealObserver.observe(item);
    });
  }

  // Scroll showcase: pre-rendered geometry, yaw only, with the final frames lighting up.
  var showcase = document.getElementById('showcase');
  if (showcase) {
    var scene = document.getElementById('rot-scene');
    var rotCanvas = document.getElementById('rot-canvas');
    var rotContext = rotCanvas ? rotCanvas.getContext('2d', { alpha: true }) : null;
    var framePrefix = rotCanvas ? rotCanvas.getAttribute('data-frame-prefix') || '' : '';
    var frameSuffix = rotCanvas ? rotCanvas.getAttribute('data-frame-suffix') || '.webp' : '.webp';
    var frameCount = rotCanvas ? parseInt(rotCanvas.getAttribute('data-frame-count'), 10) || 54 : 0;
    var frameImages = new Array(frameCount);
    var framePromises = new Array(frameCount);
    var wantedFrame = 0;
    var preloadCursor = 0;
    var stages = showcase.querySelectorAll('.sc-stage');
    var ticking = false;

    function frameUrl(index) {
      return framePrefix + String(index + 1).padStart(4, '0') + frameSuffix;
    }

    function loadFrame(index) {
      index = Math.max(0, Math.min(frameCount - 1, index));
      if (framePromises[index]) return framePromises[index];
      framePromises[index] = new Promise(function (resolve) {
        var image = new Image();
        image.decoding = 'async';
        image.onload = function () { resolve(image); };
        image.onerror = function () { resolve(null); };
        image.src = frameUrl(index);
        frameImages[index] = image;
      });
      return framePromises[index];
    }

    function paintFrame(index) {
      if (!rotContext || !frameCount) return;
      wantedFrame = Math.max(0, Math.min(frameCount - 1, index));
      loadFrame(wantedFrame).then(function (image) {
        if (!image || index !== wantedFrame) return;
        rotContext.clearRect(0, 0, rotCanvas.width, rotCanvas.height);
        rotContext.drawImage(image, 0, 0, rotCanvas.width, rotCanvas.height);
        scene.classList.add('sequence-ready');
        [-2, -1, 1, 2].forEach(function (offset) {
          var neighbor = index + offset;
          if (neighbor >= 0 && neighbor < frameCount) loadFrame(neighbor);
        });
      });
    }

    function warmSequence() {
      var loaded = 0;
      while (preloadCursor < frameCount && loaded < 4) {
        loadFrame(preloadCursor++);
        loaded += 1;
      }
      if (preloadCursor < frameCount) window.setTimeout(warmSequence, 120);
    }

    function update() {
      var rect = showcase.getBoundingClientRect();
      var scrollable = Math.max(1, rect.height - window.innerHeight);
      var progress = Math.min(1, Math.max(0, -rect.top / scrollable));

      paintFrame(Math.round(progress * (frameCount - 1)));

      // The shadow follows the same yaw path already baked into the frames.
      var travel = Math.min(1, progress / 0.76);
      var yaw = -28 + travel * 56;
      if (progress > 0.76) yaw = 28 * (1 - (progress - 0.76) / 0.24);
      var lights = Math.min(1, Math.max(0, (progress - 0.82) / 0.18));
      var facing = 0.72 + 0.28 * Math.abs(Math.cos(yaw * Math.PI / 180));
      scene.style.setProperty('--lights', lights.toFixed(3));
      scene.style.setProperty('--facing', facing.toFixed(3));

      stages.forEach(function (st) {
        var from = parseFloat(st.getAttribute('data-from'));
        var to = parseFloat(st.getAttribute('data-to'));
        var active = progress >= from && progress <= to;
        st.classList.toggle('on', active);
        st.setAttribute('aria-hidden', active ? 'false' : 'true');
        st.inert = !active;
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    if (!reducedMotion) { // static media: still drive the text stages on scroll
      paintFrame(0);
      window.setTimeout(warmSequence, 180);
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
  }

  // Close sibling FAQ items when one opens (accordion behaviour).
  var items = document.querySelectorAll('.faq-list details');
  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      items.forEach(function (other) {
        if (other !== item) other.open = false;
      });
    });
  });

  // Hero gallery thumbnails: swap main media.
  var heroStage = document.getElementById('hero-media-stage');
  var heroMedia = document.getElementById('hero-media');
  var gallerySwapId = 0;
  document.querySelectorAll('.hero-thumbs button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.hero-thumbs button').forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');

      var mediaSrc = btn.getAttribute('data-media');
      var mediaAlt = btn.getAttribute('data-alt') || 'Peakspan LaserMask';
      var mediaType = btn.getAttribute('data-type') || 'image';
      var mediaPoster = btn.getAttribute('data-poster') || '';
      var mediaWidth = parseInt(btn.getAttribute('data-width'), 10) || 901;
      var mediaHeight = parseInt(btn.getAttribute('data-height'), 10) || 1600;
      var swapId = ++gallerySwapId;

      function makeHeroMedia() {
        var next;
        if (mediaType === 'video') {
          next = document.createElement('video');
          next.src = mediaSrc;
          next.poster = mediaPoster;
          next.muted = true;
          next.loop = true;
          next.playsInline = true;
          next.controls = true;
          next.preload = 'metadata';
          next.setAttribute('aria-label', mediaAlt);
          if (!reducedMotion) next.autoplay = true;
        } else {
          next = document.createElement('img');
          next.src = mediaSrc;
          next.alt = mediaAlt;
          next.width = mediaWidth;
          next.height = mediaHeight;
          next.decoding = 'async';
          if (mediaSrc.indexOf('pick-product') !== -1) next.classList.add('is-product');
        }
        next.id = 'hero-media';
        next.classList.add('hero-media');
        return next;
      }

      var nextMedia = makeHeroMedia();
      var ready = new Promise(function (resolve) {
        var done = function () { resolve(); };
        if (mediaType === 'video') {
          nextMedia.addEventListener('loadeddata', done, { once: true });
          nextMedia.addEventListener('error', done, { once: true });
          nextMedia.load();
        } else if (nextMedia.decode) {
          nextMedia.decode().catch(function () {}).then(done);
        } else {
          nextMedia.onload = done;
          nextMedia.onerror = done;
        }
      });

      ready.then(function () {
        if (swapId !== gallerySwapId) return;
        function swapHeroMedia() {
          if (!heroStage || swapId !== gallerySwapId) return;
          if (heroMedia && heroMedia.tagName === 'VIDEO') heroMedia.pause();
          heroStage.replaceChildren(nextMedia);
          heroMedia = nextMedia;
          if (nextMedia.tagName === 'VIDEO' && !reducedMotion) nextMedia.play().catch(function () {});
        }
        if (!reducedMotion && document.startViewTransition) {
          document.startViewTransition(swapHeroMedia);
        } else {
          swapHeroMedia();
        }
      });
    });
  });

  // Keep the static design preview honest: live capture is supplied by Shopify.
  var previewWaitlist = document.querySelector('[data-preview-only]');
  if (previewWaitlist) {
    previewWaitlist.addEventListener('submit', function (event) {
      event.preventDefault();
      var previewStatus = document.getElementById('preview-form-status');
      if (previewStatus) previewStatus.textContent = 'Preview confirmed — no email was sent. Shopify customer capture activates after this theme is installed on the dedicated store.';
    });
  }

  // Launch countdown timer (real deadline from data-deadline).
  var cd = document.getElementById('countdown');
  if (cd) {
    var deadline = new Date(cd.getAttribute('data-deadline')).getTime();
    var cdEls = {
      d: document.getElementById('cd-days'),
      h: document.getElementById('cd-hours'),
      m: document.getElementById('cd-mins'),
      s: document.getElementById('cd-secs')
    };
    var pad = function (n) { return ('0' + n).slice(-2); };
    function tick() {
      var left = Math.max(0, deadline - Date.now());
      cdEls.d.textContent = pad(Math.floor(left / 864e5));
      cdEls.h.textContent = pad(Math.floor(left / 36e5) % 24);
      cdEls.m.textContent = pad(Math.floor(left / 6e4) % 60);
      cdEls.s.textContent = pad(Math.floor(left / 1e3) % 60);
      if (left <= 0) {
        clearInterval(timer);
        cd.classList.add('is-expired');
        document.documentElement.classList.add('offer-expired');
        var expiredLabel = cd.querySelector('.cd-label');
        if (expiredLabel) expiredLabel.textContent = 'Launch timing being updated';
        document.querySelectorAll('[data-offer-only]').forEach(function (element) {
          element.hidden = true;
        });
        document.querySelectorAll('[data-expired-text]').forEach(function (element) {
          element.textContent = element.getAttribute('data-expired-text');
        });
      }
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  // Before/After (off-on) comparison slider.
  var ba = document.getElementById('ba-slider');
  if (ba) {
    var top = ba.querySelector('.ba-top');
    var topImg = ba.querySelector('.ba-top .ba-img');
    var handle = ba.querySelector('.ba-handle');
    var range = ba.querySelector('.ba-range');
    function baSet(pct) {
      top.style.width = pct + '%';
      handle.style.left = pct + '%';
      // keep the ON image full-width inside the clipped container
      topImg.style.width = ba.clientWidth + 'px';
    }
    range.addEventListener('input', function () { baSet(range.value); });
    window.addEventListener('resize', function () { baSet(range.value); });
    baSet(50);
  }

  // Laser vs LED interactive comparison.
  var lab = document.getElementById('laserlab');
  if (lab) {
    var metrics = {
      laser: { angle: '18°', energy: '±2 nm', glow: 'low' },
      led:   { angle: '120°', energy: '±20 nm', glow: 'high' }
    };
    var tabs = lab.querySelectorAll('.lab-toggle button');
    function replayLabAnimation() {
      var stage = lab.querySelector('.lab-stage');
      if (!stage) return;
      var freshStage = stage.cloneNode(true);
      stage.replaceWith(freshStage);
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var mode = tab.getAttribute('data-mode');
        lab.setAttribute('data-active', mode);
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var m = metrics[mode];
        swap('m-angle', m.angle);
        swap('m-energy', m.energy);
        swap('m-glow', m.glow);
        replayLabAnimation();
      });
    });
    if ('IntersectionObserver' in window) {
      var labObserver = new IntersectionObserver(function (entries) {
        lab.classList.toggle('lab-paused', !entries[0].isIntersecting);
      }, { threshold: 0.15 });
      labObserver.observe(lab);
    }
    function swap(id, text) {
      var el = document.getElementById(id);
      el.style.opacity = '0';
      setTimeout(function () {
        el.textContent = text;
        el.style.opacity = '1';
      }, 200);
    }
  }
});

// Cart confirmation, mailing-list popup, and recently viewed products are
// progressive enhancements. Native forms and cart pages remain the fallback.
document.addEventListener('DOMContentLoaded', function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function safeStorageGet(key) {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
  }

  function safeStorageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (error) { /* Storage is optional. */ }
  }

  var cartConfirmation = document.querySelector('[data-cart-confirmation]');
  var cartConfirmationStatus = document.querySelector('[data-cart-confirmation-status]');
  var cartConfirmationClose = document.querySelector('[data-cart-confirmation-close]');
  var lastCartTrigger = null;

  function closeCartConfirmation() {
    if (!cartConfirmation || cartConfirmation.hidden) return;
    cartConfirmation.hidden = true;
    cartConfirmation.classList.remove('is-visible');
    if (lastCartTrigger) lastCartTrigger.focus();
  }

  function showCartConfirmation(message, trigger) {
    if (!cartConfirmation || !cartConfirmationStatus) return;
    lastCartTrigger = trigger || null;
    cartConfirmationStatus.textContent = message;
    cartConfirmation.hidden = false;
    cartConfirmation.classList.add('is-visible');
    if (!reducedMotion) cartConfirmation.classList.add('cart-confirmation--animate');
    window.setTimeout(function () {
      if (cartConfirmationClose && !cartConfirmation.hidden) cartConfirmationClose.focus();
    }, 0);
  }

  if (cartConfirmationClose) cartConfirmationClose.addEventListener('click', closeCartConfirmation);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCartConfirmation();
  });

  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      var button = form.querySelector('[data-cart-submit]');
      var status = form.querySelector('[data-cart-status]');
      var originalLabel = button ? button.innerHTML : '';
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding…';
      }
      if (status) status.textContent = '';

      window.fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart-add-failed');
          return response.json();
        })
        .then(function () {
          return window.fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('cart-read-failed');
          return response.json();
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (count) {
            count.textContent = String(cart.item_count || 0);
          });
          var message = 'Added to cart.';
          if (status) status.textContent = message;
          showCartConfirmation(message, button);
        })
        .catch(function () {
          var message = 'We could not update the cart. Please try again.';
          if (status) status.textContent = message;
        })
        .finally(function () {
          if (!button) return;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.innerHTML = originalLabel;
        });
    });
  });

  var popup = document.querySelector('[data-mailing-list-popup]');
  if (popup && typeof popup.showModal === 'function') {
    var popupDismissedUntil = Number(safeStorageGet('peak4beauty-mailing-list-dismissed-until') || 0);
    var popupDelay = Number(popup.getAttribute('data-popup-delay') || 6000);
    if (Date.now() > popupDismissedUntil) {
      window.setTimeout(function () {
        if (!popup.open) popup.showModal();
      }, popupDelay);
    }
    popup.addEventListener('close', function () {
      safeStorageSet('peak4beauty-mailing-list-dismissed-until', String(Date.now() + 1209600000));
    });
    popup.addEventListener('click', function (event) {
      if (event.target !== popup) return;
      var bounds = popup.getBoundingClientRect();
      var outsideDialog = event.clientX < bounds.left
        || event.clientX > bounds.right
        || event.clientY < bounds.top
        || event.clientY > bounds.bottom;
      if (outsideDialog) popup.close('dismiss');
    });
  }

  var recentProduct = document.querySelector('[data-recent-product]');
  var recentKey = 'peak4beauty-recent-products';
  var recentProducts = [];
  try { recentProducts = JSON.parse(safeStorageGet(recentKey) || '[]'); } catch (error) { recentProducts = []; }
  if (!Array.isArray(recentProducts)) recentProducts = [];

  if (recentProduct && recentProduct.dataset.productHandle && recentProduct.dataset.productUrl) {
    var entry = {
      handle: recentProduct.dataset.productHandle,
      title: recentProduct.dataset.productTitle || recentProduct.dataset.productHandle,
      url: recentProduct.dataset.productUrl,
      image: recentProduct.dataset.productImage || ''
    };
    recentProducts = recentProducts.filter(function (product) { return product && product.handle !== entry.handle; });
    recentProducts.unshift(entry);
    recentProducts = recentProducts.slice(0, 4);
    safeStorageSet(recentKey, JSON.stringify(recentProducts));
  }

  var recentSection = document.querySelector('[data-recently-viewed]');
  var recentList = document.querySelector('[data-recently-viewed-list]');
  var currentHandle = recentProduct ? recentProduct.dataset.productHandle : '';
  var displayProducts = recentProducts.filter(function (product) { return product && product.handle !== currentHandle && product.url; }).slice(0, 4);
  if (recentSection && recentList && displayProducts.length) {
    displayProducts.forEach(function (product) {
      var card = document.createElement('a');
      card.className = 'recently-viewed__card';
      card.href = product.url;
      if (product.image) {
        var image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        card.appendChild(image);
      }
      var title = document.createElement('span');
      title.textContent = product.title;
      card.appendChild(title);
      recentList.appendChild(card);
    });
    recentSection.hidden = false;
  }
});
